import React from 'react';

export const PracticeIcons = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M2.66666 5.3335L5.33332 8.00016L2.66666 10.6668" stroke="#FFBD3D" stroke-width="1.5" />
    <path d="M13.3333 5.3335L10.6667 8.00016L13.3333 10.6668" stroke="#FFBD3D" stroke-width="1.5" />
    <path d="M10.3542 2.6665L6.05881 13.1667" stroke="#F37500" stroke-width="1.5" />
  </svg>
);
